import { type FunctionComponent } from 'react';

import { Image } from '@/core/Image/Image';
import { isB2B } from '@/core/settings/utils';
import { BannerCampaign } from '@/productDiscovery/CommercialAnimation/interfaces/bannerCampaign';
import { PartnerAdBannerLabel } from '@/sellerAdsManagement/PartnerAdBannerCampaign/components/PartnerAdBannerLabel/PartnerAdBannerLabel';
import { defaultThemeColors } from '@/sellerAdsManagement/PartnerAdBannerCampaign/interfaces/themeColors';
import { usePartnerAdTheme } from '@/sellerAdsManagement/PartnerAdTheme/hooks/usePartnerAdTheme';

import fetchedImgSrc from '../../assets/b2b-background.png';

export interface PromoBlockProps {
  banner: BannerCampaign;
}

export const PromoBlock: FunctionComponent<PromoBlockProps> = ({ banner }) => {
  const theme = usePartnerAdTheme();

  const themeColors = {
    '--banner-main-color':
      theme && theme.colors ? theme.colors.main : defaultThemeColors.main,
    '--banner-accent-color':
      theme && theme.colors ? theme.colors.accent : defaultThemeColors.accent,
  };

  const b2bStyle = isB2B() ? { backgroundImage: `url(${fetchedImgSrc})` } : '';

  return (
    <div
      className="h-[280px] w-[280px] rounded-card bg-[--banner-main-color]
        bg-blend-multiply"
      style={{ ...themeColors, ...b2bStyle }}
    >
      <Image
        src={banner.image.mobileUrl}
        alt={banner.image.altText}
        title={banner.name}
        width={280}
        height={280}
        className="rounded-card"
      />
      {banner.label && (
        <div
          className="absolute left-m top-0 flex h-[152px] w-[145px] flex-col
            rounded-b-container bg-[--banner-accent-color] p-xs
            text-[--banner-main-color]"
        >
          <PartnerAdBannerLabel
            label={banner.label}
            subtitleClassName="mt-xs text-[14px] leading-[16px]"
            lineClassName="font-bold overflow-hidden text-ellipsis whitespace-nowrap"
            middleLineClassName="text-[18px]"
            smallLineClassName="text-[12px] mt-[-5px]"
            bigLineClassName="text-[36px] mt-[-10px]"
            labelClassName="flex flex-col m-s text-[--banner-main-color]"
            subtitle={banner.subtitle}
          />
          {banner.logoUrl && (
            <div
              className="mt-auto flex h-[35px] w-full justify-center
                rounded-container bg-foundation-inverted p-xs"
            >
              <Image
                className="h-auto max-h-full w-auto max-w-full object-contain"
                src={banner.logoUrl}
                alt="brand-logo"
                height={undefined}
                width={undefined}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

PromoBlock.displayName = 'PromoBlock';
